import { render, staticRenderFns } from "./baseRuleManage.vue?vue&type=template&id=7627b781&scoped=true"
import script from "./baseRuleManage.vue?vue&type=script&lang=js"
export * from "./baseRuleManage.vue?vue&type=script&lang=js"
import style0 from "./baseRuleManage.vue?vue&type=style&index=0&id=7627b781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7627b781",
  null
  
)

export default component.exports